// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 256 256%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
    :root {
        --background: 220 60% 5%;
        --foreground: 210 40% 96%;
        --card: 220 55% 8%;
        --card-foreground: 210 40% 96%;
        --popover: 220 55% 8%;
        --popover-foreground: 210 40% 96%;
        --primary: 202 100% 56%;
        --primary-foreground: 220 60% 5%;
        --secondary: 220 40% 14%;
        --secondary-foreground: 210 40% 96%;
        --muted: 220 40% 14%;
        --muted-foreground: 214 30% 68%;
        --accent: 202 100% 56%;
        --accent-foreground: 220 60% 5%;
        --destructive: 0 62% 45%;
        --destructive-foreground: 210 40% 96%;
        --border: 220 30% 20%;
        --input: 220 30% 20%;
        --ring: 202 100% 56%;
        --radius: 0.75rem;
    }
    * {
  border-color: hsl(var(--border));
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-12 {
  bottom: -3rem;
}
.-left-12 {
  left: -3rem;
}
.-right-12 {
  right: -3rem;
}
.-top-12 {
  top: -3rem;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-14 {
  top: 3.5rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[1px\\] {
  top: 1px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[60\\%\\] {
  top: 60%;
}
.top-full {
  top: 100%;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-8 {
  grid-column: span 8 / span 8;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.-mt-px {
  margin-top: -1px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-5 {
  height: 1.25rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-\\[--radix-context-menu-content-available-height\\] {
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\] {
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\] {
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[70svh\\] {
  min-height: 70svh;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-4 {
  width: 1rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-\\[1440px\\] {
  max-width: 1440px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[340px\\] {
  max-width: 340px;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-full {
  flex-basis: 100%;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\] {
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\] {
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\] {
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\] {
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\] {
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\] {
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\] {
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.list-none {
  list-style-type: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.self-end {
  align-self: flex-end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\] {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-\\[24px\\] {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}
.rounded-tl-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-\\[\\#1a1a18\\] {
  --tw-border-opacity: 1;
  border-color: rgb(26 26 24 / var(--tw-border-opacity, 1));
}
.border-\\[\\#55d0ff\\]\\/10 {
  border-color: rgb(85 208 255 / 0.1);
}
.border-\\[\\#55d0ff\\]\\/15 {
  border-color: rgb(85 208 255 / 0.15);
}
.border-\\[\\#55d0ff\\]\\/30 {
  border-color: rgb(85 208 255 / 0.3);
}
.border-\\[\\#e5e0d8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 224 216 / var(--tw-border-opacity, 1));
}
.border-destructive {
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50 {
  border-color: hsl(var(--destructive) / 0.5);
}
.border-input {
  border-color: hsl(var(--input));
}
.border-primary {
  border-color: hsl(var(--primary));
}
.border-primary\\/50 {
  border-color: hsl(var(--primary) / 0.5);
}
.border-transparent {
  border-color: transparent;
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#030812\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 8 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#030812\\]\\/80 {
  background-color: rgb(3 8 18 / 0.8);
}
.bg-\\[\\#030812\\]\\/90 {
  background-color: rgb(3 8 18 / 0.9);
}
.bg-\\[\\#faf9f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 246 / var(--tw-bg-opacity, 1));
}
.bg-accent {
  background-color: hsl(var(--accent));
}
.bg-background {
  background-color: hsl(var(--background));
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-border {
  background-color: hsl(var(--border));
}
.bg-card {
  background-color: hsl(var(--card));
}
.bg-destructive {
  background-color: hsl(var(--destructive));
}
.bg-foreground {
  background-color: hsl(var(--foreground));
}
.bg-muted {
  background-color: hsl(var(--muted));
}
.bg-muted\\/50 {
  background-color: hsl(var(--muted) / 0.5);
}
.bg-popover {
  background-color: hsl(var(--popover));
}
.bg-primary {
  background-color: hsl(var(--primary));
}
.bg-primary\\/10 {
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20 {
  background-color: hsl(var(--primary) / 0.2);
}
.bg-secondary {
  background-color: hsl(var(--secondary));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#030812\\] {
  --tw-gradient-from: #030812 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 8 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#030812\\]\\/90 {
  --tw-gradient-from: rgb(3 8 18 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 8 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#55d0ff\\] {
  --tw-gradient-from: #55d0ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(85 208 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#55d0ff\\]\\/25 {
  --tw-gradient-from: rgb(85 208 255 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(85 208 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#030812\\]\\/20 {
  --tw-gradient-to: rgb(3 8 18 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(3 8 18 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#030812\\]\\/40 {
  --tw-gradient-to: rgb(3 8 18 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(3 8 18 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#030812\\]\\/75 {
  --tw-gradient-to: rgb(3 8 18 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(3 8 18 / 0.75) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#030812\\]\\/85 {
  --tw-gradient-to: rgb(3 8 18 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(3 8 18 / 0.85) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#030812\\]\\/30 {
  --tw-gradient-to: rgb(3 8 18 / 0.3) var(--tw-gradient-to-position);
}
.to-\\[\\#030812\\]\\/40 {
  --tw-gradient-to: rgb(3 8 18 / 0.4) var(--tw-gradient-to-position);
}
.to-\\[\\#030812\\]\\/50 {
  --tw-gradient-to: rgb(3 8 18 / 0.5) var(--tw-gradient-to-position);
}
.to-\\[\\#030812\\]\\/60 {
  --tw-gradient-to: rgb(3 8 18 / 0.6) var(--tw-gradient-to-position);
}
.to-\\[\\#0b6cc9\\] {
  --tw-gradient-to: #0b6cc9 var(--tw-gradient-to-position);
}
.to-\\[\\#0b6cc9\\]\\/20 {
  --tw-gradient-to: rgb(11 108 201 / 0.2) var(--tw-gradient-to-position);
}
.to-\\[\\#0b6cc9\\]\\/25 {
  --tw-gradient-to: rgb(11 108 201 / 0.25) var(--tw-gradient-to-position);
}
.to-\\[\\#1fa8ff\\] {
  --tw-gradient-to: #1fa8ff var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.fill-current {
  fill: currentColor;
}
.fill-primary {
  fill: hsl(var(--primary));
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[1px\\] {
  padding: 1px;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[4\\.75rem\\] {
  padding-top: 4.75rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[0\\.7rem\\] {
  font-size: 0.7rem;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.leading-\\[1\\.04\\] {
  line-height: 1.04;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#1a1a18\\] {
  --tw-text-opacity: 1;
  color: rgb(26 26 24 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a1a18\\]\\/60 {
  color: rgb(26 26 24 / 0.6);
}
.text-\\[\\#1a1a18\\]\\/70 {
  color: rgb(26 26 24 / 0.7);
}
.text-\\[\\#55d0ff\\] {
  --tw-text-opacity: 1;
  color: rgb(85 208 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#55d0ff\\]\\/50 {
  color: rgb(85 208 255 / 0.5);
}
.text-\\[\\#8c7a6b\\] {
  --tw-text-opacity: 1;
  color: rgb(140 122 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8ea6c8\\] {
  --tw-text-opacity: 1;
  color: rgb(142 166 200 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a7bcd6\\] {
  --tw-text-opacity: 1;
  color: rgb(167 188 214 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a7e2ff\\] {
  --tw-text-opacity: 1;
  color: rgb(167 226 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b8c9e4\\] {
  --tw-text-opacity: 1;
  color: rgb(184 201 228 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c2a878\\] {
  --tw-text-opacity: 1;
  color: rgb(194 168 120 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c8d6ec\\] {
  --tw-text-opacity: 1;
  color: rgb(200 214 236 / var(--tw-text-opacity, 1));
}
.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.text-card-foreground {
  color: hsl(var(--card-foreground));
}
.text-current {
  color: currentColor;
}
.text-destructive {
  color: hsl(var(--destructive));
}
.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.text-foreground {
  color: hsl(var(--foreground));
}
.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}
.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}
.text-primary {
  color: hsl(var(--primary));
}
.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.overline {
  text-decoration-line: overline;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[\\#1fa8ff\\]\\/40 {
  --tw-shadow-color: rgb(31 168 255 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-ring {
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.drop-shadow-\\[0_0_8px_rgba\\(85\\2c 208\\2c 255\\2c 0\\.6\\)\\] {
  --tw-drop-shadow: drop-shadow(0 0 8px rgba(85,208,255,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_4px_24px_rgba\\(31\\2c 168\\2c 255\\2c 0\\.55\\)\\] {
  --tw-drop-shadow: drop-shadow(0 4px 24px rgba(31,168,255,0.55));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_4px_24px_rgba\\(31\\2c 168\\2c 255\\2c 0\\.6\\)\\] {
  --tw-drop-shadow: drop-shadow(0 4px 24px rgba(31,168,255,0.6));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.duration-1000 {
  animation-duration: 1000ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.duration-700 {
  animation-duration: 700ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* TOP WASH DOO — chrome + electric blue, dark stage */
:root {
    --tw-bg: #030812;
    --tw-bg-2: #071223;
    --tw-surface: #0c1a30;
    --tw-fg: #eaf2ff;
    --tw-muted: #8ea6c8;
    --tw-blue: #1fa8ff;
    --tw-blue-bright: #55d0ff;
    --tw-blue-deep: #0b6cc9;
    --tw-chrome-1: #f4f7fb;
    --tw-chrome-2: #cfd8e6;
    --tw-chrome-3: #8ea1b8;
    --tw-border: rgba(139, 178, 226, 0.14);
}

html,
body {
    background: var(--tw-bg);
    color: var(--tw-fg);
    overflow-x: hidden;
    max-width: 100vw;
}

img,
video {
    max-width: 100%;
    height: auto;
}

/* Minimum touch target (44px) for mobile accessibility */
.touch-target {
    min-width: 44px;
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.safe-top {
    padding-top: env(safe-area-inset-top, 0px);
}

body {
    margin: 0;
    font-family:
        "Manrope",
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        Roboto,
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
}

.font-display {
    font-family: "Archivo Black", "Manrope", sans-serif;
    letter-spacing: -0.02em;
    font-style: italic;
    text-transform: uppercase;
}
.font-display-str {
    font-family: "Archivo Black", "Manrope", sans-serif;
    letter-spacing: -0.02em;
    text-transform: uppercase;
}
.font-heading {
    font-family: "Sora", "Manrope", sans-serif;
    font-weight: 800;
    letter-spacing: -0.03em;
    line-height: 0.98;
}
.font-heading-md {
    font-family: "Sora", "Manrope", sans-serif;
    font-weight: 700;
    letter-spacing: -0.02em;
}
.font-sans-tw {
    font-family: "Manrope", -apple-system, BlinkMacSystemFont, sans-serif;
}

.overline {
    font-family: "Manrope", sans-serif;
    text-transform: uppercase;
    letter-spacing: 0.18em;
    font-size: 0.65rem;
    font-weight: 700;
    color: var(--tw-blue-bright);
    line-height: 1.4;
}
@media (min-width: 640px) {
    .overline {
        letter-spacing: 0.28em;
        font-size: 0.72rem;
    }
}

/* Chrome/silver metallic text */
.chrome-text {
    background: linear-gradient(
        180deg,
        #ffffff 0%,
        #dfe7f1 30%,
        #8ea1b8 55%,
        #ffffff 60%,
        #cfd8e6 80%,
        #6e7f96 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-stroke: 1px rgba(255, 255, 255, 0.14);
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.08);
    filter: drop-shadow(0 6px 24px rgba(31, 168, 255, 0.35));
}

/* Electric blue heading */
.blue-text {
    background: linear-gradient(
        180deg,
        #a7e2ff 0%,
        #55d0ff 35%,
        #1fa8ff 55%,
        #0b6cc9 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    filter: drop-shadow(0 6px 24px rgba(31, 168, 255, 0.55));
}

/* Ambient glow blob */
.glow-blob {
    position: absolute;
    filter: blur(80px);
    opacity: 0.55;
    pointer-events: none;
    z-index: 0;
}

/* Selection */
::selection {
    background: var(--tw-blue);
    color: #030812;
}

/* Scrollbar */
::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
::-webkit-scrollbar-track {
    background: var(--tw-bg);
}
::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #1fa8ff, #0b6cc9);
    border-radius: 999px;
}

/* Marquee */
@keyframes tw-marquee {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-50%);
    }
}
.tw-marquee-track {
    animation: tw-marquee 32s linear infinite;
}

/* Nav link */
.tw-link {
    position: relative;
    display: inline-block;
    padding-bottom: 3px;
    color: rgba(234, 242, 255, 0.75);
    transition: color 0.3s ease;
}
.tw-link:hover {
    color: #55d0ff;
}
.tw-link::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, #1fa8ff, #55d0ff);
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.5s cubic-bezier(0.77, 0, 0.175, 1);
}
.tw-link:hover::after {
    transform-origin: left;
    transform: scaleX(1);
}

/* Buttons */
.tw-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 0.9rem 1.5rem;
    background: linear-gradient(180deg, #55d0ff 0%, #1fa8ff 50%, #0b6cc9 100%);
    color: #041225;
    font-family: "Archivo Black", sans-serif;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    font-size: 0.78rem;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow:
        0 0 0 1px rgba(11, 108, 201, 0.5),
        0 12px 32px -8px rgba(31, 168, 255, 0.6),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
    transition: transform 0.35s ease, box-shadow 0.35s ease, filter 0.35s ease;
}
.tw-btn:hover {
    transform: translateY(-2px) scale(1.02);
    filter: brightness(1.08);
    box-shadow:
        0 0 0 1px rgba(85, 208, 255, 0.7),
        0 18px 42px -6px rgba(31, 168, 255, 0.8),
        inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.tw-btn-ghost {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 0.9rem 1.5rem;
    background: rgba(255, 255, 255, 0.04);
    color: #eaf2ff;
    border: 1px solid rgba(139, 178, 226, 0.35);
    backdrop-filter: blur(12px);
    font-family: "Archivo Black", sans-serif;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    font-size: 0.78rem;
    border-radius: 999px;
    transition: all 0.35s ease;
}
@media (min-width: 640px) {
    .tw-btn,
    .tw-btn-ghost {
        padding: 1rem 1.8rem;
    }
}
.tw-btn-ghost:hover {
    background: rgba(31, 168, 255, 0.12);
    border-color: rgba(85, 208, 255, 0.7);
    color: #55d0ff;
}

/* Card with glass + chrome border */
.tw-card {
    position: relative;
    background:
        linear-gradient(180deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0) 100%),
        rgba(12, 26, 48, 0.55);
    border: 1px solid rgba(139, 178, 226, 0.14);
    border-radius: 16px;
    backdrop-filter: blur(14px);
    overflow: hidden;
    transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1),
        border-color 0.4s ease, box-shadow 0.4s ease;
}
@media (min-width: 640px) {
    .tw-card {
        border-radius: 20px;
    }
}
@media (min-width: 768px) {
    .tw-card {
        border-radius: 24px;
    }
}
.tw-card::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: 24px;
    background: linear-gradient(
        140deg,
        rgba(85, 208, 255, 0.35),
        rgba(139, 178, 226, 0.06) 40%,
        rgba(85, 208, 255, 0) 65%,
        rgba(85, 208, 255, 0.25) 100%
    );
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    mask-composite: exclude;
    pointer-events: none;
}
.tw-card:hover {
    transform: translateY(-6px);
    border-color: rgba(85, 208, 255, 0.4);
    box-shadow: 0 30px 60px -20px rgba(31, 168, 255, 0.28);
}

/* Grid divider lines */
.tw-hr {
    height: 1px;
    width: 100%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(139, 178, 226, 0.28),
        transparent
    );
}

/* Section base */
.tw-section {
    position: relative;
    padding-top: 4rem;
    padding-bottom: 4rem;
}
@media (min-width: 640px) {
    .tw-section {
        padding-top: 5rem;
        padding-bottom: 5rem;
    }
}
@media (min-width: 768px) {
    .tw-section {
        padding-top: 8rem;
        padding-bottom: 8rem;
    }
}

/* Layout container */
.tw-container {
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding-left: max(1rem, env(safe-area-inset-left, 1rem));
    padding-right: max(1rem, env(safe-area-inset-right, 1rem));
}
@media (min-width: 640px) {
    .tw-container {
        padding-left: max(1.25rem, env(safe-area-inset-left, 1.25rem));
        padding-right: max(1.25rem, env(safe-area-inset-right, 1.25rem));
    }
}
@media (min-width: 768px) {
    .tw-container {
        padding-left: max(2.5rem, env(safe-area-inset-left, 2.5rem));
        padding-right: max(2.5rem, env(safe-area-inset-right, 2.5rem));
    }
}

/* Responsive section headings */
.tw-heading-section {
    font-family: "Sora", "Manrope", sans-serif;
    font-weight: 800;
    letter-spacing: -0.03em;
    line-height: 1.05;
    font-size: clamp(2rem, 5.5vw, 3.75rem);
    color: #ffffff;
}

/* ─── Luxury Hero ─── */
.hero-luxury .hero-grain {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mix-blend-mode: overlay;
    pointer-events: none;
}

.hero-badge {
    display: inline-flex;
    align-items: flex-start;
    gap: 0.5rem;
    max-width: 100%;
    padding: 0.5rem 0.85rem;
    border-radius: 999px;
    border: 1px solid rgba(85, 208, 255, 0.28);
    background: rgba(3, 8, 18, 0.55);
    backdrop-filter: blur(14px);
    font-size: 0.58rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #a7e2ff;
}
@media (min-width: 640px) {
    .hero-badge {
        align-items: center;
        font-size: 0.72rem;
        letter-spacing: 0.22em;
        padding: 0.6rem 1.15rem;
        gap: 0.6rem;
    }
}

.hero-title {
    font-family: "Sora", "Manrope", sans-serif;
    font-weight: 300;
    font-size: clamp(1.65rem, 5.5vw, 4.5rem);
    line-height: 1.12;
    letter-spacing: -0.03em;
    color: #ffffff;
}
@media (min-width: 640px) {
    .hero-title {
        line-height: 1.08;
    }
}
.hero-title-accent {
    font-weight: 700;
    background: linear-gradient(135deg, #e8f4ff 0%, #55d0ff 45%, #1fa8ff 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

.hero-usps {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.5rem 1rem;
}
@media (min-width: 480px) {
    .hero-usps {
        grid-template-columns: repeat(2, 1fr);
    }
}

.hero-usp {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: #c8d6ec;
    line-height: 1.4;
}
@media (min-width: 640px) {
    .hero-usp {
        font-size: 0.82rem;
    }
}

/* ─── Partner strip ─── */
.partner-strip {
    padding: 3rem 0;
    border-top: 1px solid rgba(85, 208, 255, 0.08);
    border-bottom: 1px solid rgba(85, 208, 255, 0.08);
    background: linear-gradient(180deg, rgba(6, 16, 31, 0.6) 0%, rgba(3, 8, 18, 0.3) 100%);
}
@media (min-width: 640px) {
    .partner-strip {
        padding: 4rem 0;
    }
}

.partner-logos {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
}
@media (min-width: 640px) {
    .partner-logos {
        grid-template-columns: repeat(4, 1fr);
        gap: 1rem;
    }
}

.partner-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.85rem 1rem;
    border-radius: 1rem;
    border: 1px solid rgba(139, 178, 226, 0.12);
    background: rgba(3, 8, 18, 0.5);
    transition: border-color 0.35s, background 0.35s, transform 0.35s;
}
.partner-logo:hover {
    border-color: rgba(85, 208, 255, 0.35);
    background: rgba(85, 208, 255, 0.06);
    transform: translateY(-2px);
}

.partner-logo__img {
    height: 1.75rem;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    color: #ffffff;
    opacity: 0.85;
    filter: brightness(0) invert(1);
    transition: opacity 0.35s;
}
.partner-logo:hover .partner-logo__img {
    opacity: 1;
}
@media (min-width: 640px) {
    .partner-logo__img {
        height: 2rem;
    }
}

.partner-logo__role {
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-align: center;
    color: #8ea6c8;
    line-height: 1.3;
}

.hero-mosaic {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: 0.5rem;
    max-width: 340px;
    margin: 0 auto;
}
.hero-mosaic--compact .hero-mosaic-item {
    aspect-ratio: 1 / 1;
}
.hero-mosaic--compact .hero-mosaic-item--1,
.hero-mosaic--compact .hero-mosaic-item--2,
.hero-mosaic--compact .hero-mosaic-item--3,
.hero-mosaic--compact .hero-mosaic-item--4 {
    margin-top: 0;
}
@media (min-width: 640px) {
    .hero-mosaic {
        gap: 1rem;
        max-width: none;
    }
    .hero-mosaic--compact .hero-mosaic-item {
        aspect-ratio: 3 / 4;
    }
    .hero-mosaic--compact .hero-mosaic-item--2 {
        margin-top: 1.5rem;
    }
    .hero-mosaic--compact .hero-mosaic-item--3 {
        margin-top: -1rem;
    }
}
@media (min-width: 1024px) {
    .hero-mosaic {
        gap: 1.15rem;
    }
}

.hero-mosaic-item {
    position: relative;
    overflow: hidden;
    border-radius: 1.25rem;
    border: 1px solid rgba(139, 178, 226, 0.18);
    aspect-ratio: 4 / 5;
}
@media (min-width: 640px) {
    .hero-mosaic-item {
        border-radius: 1.5rem;
    }
}
.hero-mosaic-item--1 { aspect-ratio: 1 / 1; }
.hero-mosaic-item--2 { aspect-ratio: 1 / 1; margin-top: 0; }
.hero-mosaic-item--3 { aspect-ratio: 1 / 1; margin-top: 0; }
.hero-mosaic-item--4 { aspect-ratio: 1 / 1; }

@media (min-width: 640px) {
    .hero-mosaic-item--1 { aspect-ratio: 3 / 4; }
    .hero-mosaic-item--2 { aspect-ratio: 3 / 4; margin-top: 1.5rem; }
    .hero-mosaic-item--3 { aspect-ratio: 3 / 4; margin-top: -1rem; }
    .hero-mosaic-item--4 { aspect-ratio: 3 / 4; }
}

@media (min-width: 1024px) {
    .hero-mosaic-item--2 { margin-top: 3rem; }
    .hero-mosaic-item--3 { margin-top: -2.5rem; }
}

.hero-mosaic-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}
.hero-mosaic-item:hover img {
    transform: scale(1.06);
}

.hero-mosaic-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
        to top,
        rgba(3, 8, 18, 0.85) 0%,
        rgba(3, 8, 18, 0.1) 55%,
        transparent 100%
    );
}

.hero-mosaic-label {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #ffffff;
    z-index: 2;
}
@media (min-width: 640px) {
    .hero-mosaic-label {
        font-size: 0.72rem;
        left: 1.25rem;
        bottom: 1.25rem;
    }
}

.hero-mosaic-frame {
    position: absolute;
    inset: -8px;
    border-radius: 1.75rem;
    border: 1px solid rgba(85, 208, 255, 0.12);
    pointer-events: none;
    display: none;
}
@media (min-width: 1024px) {
    .hero-mosaic-frame { display: block; }
}

.hero-stats {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0.75rem;
    padding: 1rem;
    border-radius: 1.25rem;
    border: 1px solid rgba(139, 178, 226, 0.14);
    background: rgba(3, 8, 18, 0.65);
    backdrop-filter: blur(16px);
}
@media (min-width: 640px) {
    .hero-stats {
        grid-template-columns: repeat(3, 1fr);
        gap: 1rem;
        padding: 1.25rem 1.5rem;
        border-radius: 1.5rem;
    }
}

.hero-stat {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    padding: 0.5rem 0;
}
@media (min-width: 640px) {
    .hero-stat {
        padding: 0.25rem 0;
        border-right: 1px solid rgba(139, 178, 226, 0.1);
    }
    .hero-stat:last-child { border-right: none; }
}

@media (max-width: 639px) {
    .hero-stat + .hero-stat {
        border-top: 1px solid rgba(139, 178, 226, 0.1);
        padding-top: 0.75rem;
    }
}

.hero-stat-icon {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(85, 208, 255, 0.2), rgba(11, 108, 201, 0.15));
    border: 1px solid rgba(85, 208, 255, 0.25);
    flex-shrink: 0;
}

/* ─── Process / How it works ─── */
.process-section {
    background: linear-gradient(180deg, #030812 0%, #06101f 45%, #030812 100%);
}

.process-section__glow {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    width: min(900px, 90vw);
    height: 400px;
    background: radial-gradient(ellipse, rgba(31, 168, 255, 0.12) 0%, transparent 70%);
    pointer-events: none;
}

.process-progress {
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    max-width: 1100px;
    margin-left: auto;
    margin-right: auto;
}

.process-progress__segment {
    display: flex;
    align-items: center;
    flex: 1 1;
}

.process-progress__segment:last-child {
    flex: 0 1;
}

.process-progress__dot {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Sora", sans-serif;
    font-weight: 800;
    font-size: 0.75rem;
    color: #ffffff;
    background: linear-gradient(135deg, #55d0ff, #0b6cc9);
    box-shadow: 0 0 24px rgba(31, 168, 255, 0.45);
    flex-shrink: 0;
}

.process-progress__line {
    flex: 1 1;
    height: 2px;
    margin: 0 0.5rem;
    background: linear-gradient(90deg, #55d0ff, rgba(85, 208, 255, 0.15));
}

.process-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.25rem;
    max-width: 1200px;
    margin: 0 auto;
}
@media (min-width: 640px) {
    .process-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
    }
}
@media (min-width: 1024px) {
    .process-grid {
        grid-template-columns: repeat(4, 1fr);
        gap: 1.25rem;
    }
}

.process-card {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 1.5rem 1.25rem 1.5rem 1.75rem;
    border-radius: 1.25rem;
    border: 1px solid rgba(139, 178, 226, 0.12);
    background: linear-gradient(
        145deg,
        rgba(12, 26, 48, 0.7) 0%,
        rgba(3, 8, 18, 0.85) 100%
    );
    backdrop-filter: blur(12px);
    overflow: hidden;
    transition: border-color 0.4s ease, box-shadow 0.4s ease, transform 0.4s ease;
}
@media (min-width: 640px) {
    .process-card {
        padding: 1.75rem;
        min-height: 320px;
    }
}
@media (min-width: 1024px) {
    .process-card {
        min-height: 340px;
        padding: 2rem 1.5rem;
    }
}

.process-card::before {
    content: "";
    position: absolute;
    left: 0;
    top: 1.25rem;
    bottom: 1.25rem;
    width: 3px;
    border-radius: 999px;
    background: linear-gradient(180deg, #55d0ff, #0b6cc9);
    opacity: 0.7;
    transition: opacity 0.4s ease;
}
@media (min-width: 640px) {
    .process-card::before {
        top: 1.5rem;
        bottom: 1.5rem;
    }
}

.process-card:hover {
    border-color: rgba(85, 208, 255, 0.35);
    box-shadow: 0 20px 50px -20px rgba(31, 168, 255, 0.35);
    transform: translateY(-4px);
}
.process-card:hover::before {
    opacity: 1;
}

.process-card__watermark {
    position: absolute;
    top: -0.25rem;
    right: 0.75rem;
    font-family: "Sora", sans-serif;
    font-weight: 800;
    font-size: 4.5rem;
    line-height: 1;
    color: rgba(85, 208, 255, 0.06);
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}
@media (min-width: 1024px) {
    .process-card__watermark {
        font-size: 5rem;
        right: 0.5rem;
    }
}

.process-card__vline {
    display: none;
}

.process-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.25rem;
    position: relative;
    z-index: 1;
}

.process-card__icon {
    width: 3rem;
    height: 3rem;
    border-radius: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(85, 208, 255, 0.18), rgba(11, 108, 201, 0.12));
    border: 1px solid rgba(85, 208, 255, 0.28);
}

.process-card__index {
    font-family: "Sora", sans-serif;
    font-weight: 800;
    font-size: 0.8rem;
    color: #55d0ff;
    letter-spacing: 0.1em;
}

.process-card__title {
    position: relative;
    z-index: 1;
    font-family: "Sora", sans-serif;
    font-weight: 700;
    font-size: 1.1rem;
    line-height: 1.3;
    color: #ffffff;
    letter-spacing: -0.02em;
}
@media (min-width: 768px) {
    .process-card__title {
        font-size: 1.2rem;
    }
}

.process-card__desc {
    position: relative;
    z-index: 1;
    margin-top: 0.75rem;
    flex: 1 1;
    font-size: 0.875rem;
    line-height: 1.65;
    color: #a7bcd6;
}
@media (min-width: 768px) {
    .process-card__desc {
        font-size: 0.9rem;
    }
}

.process-card__footer {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.25rem;
    padding-top: 1.25rem;
    border-top: 1px solid rgba(139, 178, 226, 0.1);
}

.process-card__tag {
    display: inline-flex;
    padding: 0.4rem 0.85rem;
    border-radius: 999px;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #a7e2ff;
    background: rgba(85, 208, 255, 0.1);
    border: 1px solid rgba(85, 208, 255, 0.22);
}
@media (min-width: 640px) {
    .process-card__tag {
        font-size: 0.65rem;
    }
}

/* ─── Service pages ─── */
.service-hero__title {
    font-family: "Sora", "Manrope", sans-serif;
    font-weight: 700;
    font-size: clamp(1.75rem, 5vw, 3.25rem);
    line-height: 1.1;
    letter-spacing: -0.03em;
    color: #ffffff;
}

.service-breadcrumb {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem 0.5rem;
    font-size: 0.72rem;
    color: #8ea6c8;
}
.service-breadcrumb a {
    color: #a7e2ff;
    transition: color 0.3s;
}
.service-breadcrumb a:hover {
    color: #55d0ff;
}
.service-breadcrumb span[aria-current] {
    color: #ffffff;
}

.service-highlights {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}
.service-highlight {
    display: flex;
    flex-direction: column;
    padding: 0.65rem 1rem;
    border-radius: 0.85rem;
    background: rgba(3, 8, 18, 0.65);
    border: 1px solid rgba(85, 208, 255, 0.18);
    backdrop-filter: blur(10px);
    min-width: 5.5rem;
}
.service-highlight__value {
    font-family: "Sora", sans-serif;
    font-weight: 800;
    font-size: 0.95rem;
    color: #ffffff;
}
.service-highlight__label {
    font-size: 0.6rem;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #8ea6c8;
    margin-top: 0.15rem;
}

.service-panel {
    padding: 1.5rem;
    border-radius: 1.25rem;
    border: 1px solid rgba(139, 178, 226, 0.12);
    background: linear-gradient(145deg, rgba(12, 26, 48, 0.55), rgba(3, 8, 18, 0.8));
}
@media (min-width: 640px) {
    .service-panel {
        padding: 2rem;
    }
}
.service-panel__icon {
    width: 3rem;
    height: 3rem;
    border-radius: 0.85rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(85, 208, 255, 0.15), rgba(11, 108, 201, 0.1));
    border: 1px solid rgba(85, 208, 255, 0.25);
    margin-bottom: 1rem;
}
.service-panel__title {
    font-family: "Sora", sans-serif;
    font-weight: 700;
    font-size: 1.15rem;
    color: #ffffff;
}

.service-chip {
    display: inline-flex;
    padding: 0.4rem 0.9rem;
    border-radius: 999px;
    font-size: 0.75rem;
    font-weight: 600;
    color: #c8d6ec;
    background: rgba(85, 208, 255, 0.08);
    border: 1px solid rgba(85, 208, 255, 0.15);
}

.service-content-block {
    padding-bottom: 1.5rem;
    border-bottom: 1px solid rgba(139, 178, 226, 0.08);
}

.service-local {
    padding: 1.5rem;
    border-radius: 1.25rem;
    border: 1px solid rgba(85, 208, 255, 0.15);
    background: rgba(85, 208, 255, 0.04);
}
@media (min-width: 640px) {
    .service-local {
        padding: 2rem;
    }
}

.service-faq {
    border-radius: 1rem;
    border: 1px solid rgba(139, 178, 226, 0.12);
    background: rgba(12, 26, 48, 0.4);
    overflow: hidden;
    transition: border-color 0.3s;
}
.service-faq[open] {
    border-color: rgba(85, 208, 255, 0.3);
}
.service-faq__q {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem 1.25rem;
    font-family: "Sora", sans-serif;
    font-weight: 600;
    font-size: 0.9rem;
    color: #ffffff;
    cursor: pointer;
    list-style: none;
}
.service-faq__q::-webkit-details-marker {
    display: none;
}
.service-faq__chevron {
    color: #55d0ff;
    transition: transform 0.3s;
}
.service-faq[open] .service-faq__chevron {
    transform: rotate(90deg);
}
.service-faq__a {
    padding: 0 1.25rem 1.25rem;
    font-size: 0.875rem;
    line-height: 1.65;
    color: #a7bcd6;
}

.service-related {
    display: block;
    border-radius: 1.25rem;
    border: 1px solid rgba(139, 178, 226, 0.12);
    background: rgba(12, 26, 48, 0.4);
    overflow: hidden;
    transition: border-color 0.4s, box-shadow 0.4s;
}
.service-related:hover {
    border-color: rgba(85, 208, 255, 0.35);
    box-shadow: 0 16px 40px -16px rgba(31, 168, 255, 0.3);
}
.service-related__img {
    position: relative;
    height: 10rem;
    overflow: hidden;
}
@media (min-width: 640px) {
    .service-related__img {
        height: 11rem;
    }
}

.service-cta-band {
    background: linear-gradient(180deg, #06101f 0%, #030812 100%);
    border-top: 1px solid rgba(85, 208, 255, 0.12);
}

.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}


html {
    scroll-behavior: smooth;
}

/* Shadcn compat */

/* Bubble float animation */
@keyframes bubble-float {
    0% {
        transform: translateY(0) translateX(0) scale(1);
        opacity: 0;
    }
    10% {
        opacity: 0.8;
    }
    90% {
        opacity: 0.6;
    }
    100% {
        transform: translateY(-120vh) translateX(20px) scale(0.6);
        opacity: 0;
    }
}
.bubble {
    position: absolute;
    border-radius: 999px;
    background: radial-gradient(
        circle at 30% 30%,
        rgba(255, 255, 255, 0.6),
        rgba(85, 208, 255, 0.3) 40%,
        rgba(11, 108, 201, 0.05) 70%,
        transparent 80%
    );
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: inset 0 0 12px rgba(85, 208, 255, 0.35),
        0 0 20px rgba(31, 168, 255, 0.25);
    pointer-events: none;
}

/* Grid noise/dots background */
.dots-bg {
    background-image: radial-gradient(
        rgba(85, 208, 255, 0.13) 1px,
        transparent 1px
    );
    background-size: 26px 26px;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}
.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button {
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}
.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after {
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child {
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.focus-within\\:z-20:focus-within {
  z-index: 20;
}
.hover\\:bg-\\[\\#f2efe9\\]\\/60:hover {
  background-color: rgb(242 239 233 / 0.6);
}
.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}
.hover\\:bg-destructive\\/80:hover {
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-muted:hover {
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover {
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover {
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover {
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-secondary:hover {
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-white\\/40:hover {
  background-color: rgb(255 255 255 / 0.4);
}
.hover\\:text-\\[\\#55d0ff\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(85 208 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}
.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover {
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover {
  color: hsl(var(--primary-foreground));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus {
  background-color: hsl(var(--primary));
}
.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus {
  color: hsl(var(--primary-foreground));
}
.focus\\:opacity-100:focus {
  opacity: 1;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:text-\\[\\#55d0ff\\] {
  --tw-text-opacity: 1;
  color: rgb(85 208 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border {
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted {
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary {
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background {
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground {
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"] {
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"] {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up {

  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down {

  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"] {
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder] {
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"] {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"] {
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:border-destructive:is(.dark *) {
  border-color: hsl(var(--destructive));
}
@media (min-width: 640px) {

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:top-16 {
    top: 4rem;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .sm\\:mb-14 {
    margin-bottom: 3.5rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-1 {
    margin-top: 0.25rem;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:mt-12 {
    margin-top: 3rem;
  }

  .sm\\:mt-4 {
    margin-top: 1rem;
  }

  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:mt-8 {
    margin-top: 2rem;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-24 {
    height: 6rem;
  }

  .sm\\:h-44 {
    height: 11rem;
  }

  .sm\\:h-\\[4\\.5rem\\] {
    height: 4.5rem;
  }

  .sm\\:min-h-\\[220px\\] {
    min-height: 220px;
  }

  .sm\\:min-h-\\[75vh\\] {
    min-height: 75vh;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-\\[220px\\] {
    max-width: 220px;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .sm\\:pb-14 {
    padding-bottom: 3.5rem;
  }

  .sm\\:pr-10 {
    padding-right: 2.5rem;
  }

  .sm\\:pt-12 {
    padding-top: 3rem;
  }

  .sm\\:pt-28 {
    padding-top: 7rem;
  }

  .sm\\:pt-32 {
    padding-top: 8rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:tracking-\\[0\\.2em\\] {
    letter-spacing: 0.2em;
  }

  .sm\\:opacity-25 {
    opacity: 0.25;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:col-start-7 {
    grid-column-start: 7;
  }

  .md\\:col-start-8 {
    grid-column-start: 8;
  }

  .md\\:mb-16 {
    margin-bottom: 4rem;
  }

  .md\\:mb-20 {
    margin-bottom: 5rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:mt-12 {
    margin-top: 3rem;
  }

  .md\\:mt-6 {
    margin-top: 1.5rem;
  }

  .md\\:mt-8 {
    margin-top: 2rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:h-16 {
    height: 4rem;
  }

  .md\\:h-20 {
    height: 5rem;
  }

  .md\\:h-28 {
    height: 7rem;
  }

  .md\\:h-48 {
    height: 12rem;
  }

  .md\\:min-h-\\[220px\\] {
    min-height: 220px;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-14 {
    gap: 3.5rem;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:space-y-10 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
  }

  .md\\:to-\\[\\#030812\\]\\/50 {
    --tw-gradient-to: rgb(3 8 18 / 0.5) var(--tw-gradient-to-position);
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-14 {
    padding: 3.5rem;
  }

  .md\\:p-7 {
    padding: 1.75rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .md\\:pb-12 {
    padding-bottom: 3rem;
  }

  .md\\:pb-16 {
    padding-bottom: 4rem;
  }

  .md\\:pr-14 {
    padding-right: 3.5rem;
  }

  .md\\:pt-32 {
    padding-top: 8rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:top-24 {
    top: 6rem;
  }

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:mt-14 {
    margin-top: 3.5rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[4\\.25rem\\] {
    height: 4.25rem;
  }

  .lg\\:h-\\[5\\.25rem\\] {
    height: 5.25rem;
  }

  .lg\\:min-h-\\[calc\\(100svh-5\\.25rem\\)\\] {
    min-height: calc(100svh - 5.25rem);
  }

  .lg\\:max-w-none {
    max-width: none;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:pt-36 {
    padding-top: 9rem;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }
}
@media (min-width: 1280px) {

  .xl\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .xl\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:gap-16 {
    gap: 4rem;
  }

  .xl\\:gap-4 {
    gap: 1rem;
  }

  .xl\\:gap-8 {
    gap: 2rem;
  }

  .xl\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .xl\\:text-\\[0\\.78rem\\] {
    font-size: 0.78rem;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start) {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]) {
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside) {
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg {
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg {
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg {
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg {
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg {
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;IAAd;QAAA,wBAAc;QAAd,yBAAc;QAAd,kBAAc;QAAd,8BAAc;QAAd,qBAAc;QAAd,iCAAc;QAAd,uBAAc;QAAd,gCAAc;QAAd,wBAAc;QAAd,mCAAc;QAAd,oBAAc;QAAd,+BAAc;QAAd,sBAAc;QAAd,+BAAc;QAAd,wBAAc;QAAd,qCAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,oBAAc;QAAd,iBAAc;IAAA;IAAd;EAAA;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,sDAAsD;AACtD;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;;IAEI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA,yDAAyD;AACzD;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT;;;;;;kBAMc;IACd,mCAAmC;IACnC,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,mDAAmD;IACnD,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,mDAAmD;IACnD,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,qEAAqE;AACzE;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;;AAEA,gCAAgC;AAChC;IACI;;;;;;;;KAQC;IACD,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,kDAAkD;IAClD,8CAA8C;IAC9C,wDAAwD;AAC5D;;AAEA,0BAA0B;AAC1B;IACI;;;;;;KAMC;IACD,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,UAAU;AACd;;AAEA,cAAc;AACd;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA,YAAY;AACZ;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI,yCAAyC;AAC7C;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,gCAAgC;IAChC,2BAA2B;AAC/B;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,WAAW;IACX,oDAAoD;IACpD,uBAAuB;IACvB,oBAAoB;IACpB,0DAA0D;AAC9D;AACA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,0EAA0E;IAC1E,cAAc;IACd,wCAAwC;IACxC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,0CAA0C;IAC1C;;;8CAG0C;IAC1C,0EAA0E;AAC9E;AACA;IACI,uCAAuC;IACvC,wBAAwB;IACxB;;;8CAG0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,qCAAqC;IACrC,cAAc;IACd,2CAA2C;IAC3C,2BAA2B;IAC3B,wCAAwC;IACxC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,0BAA0B;AAC9B;AACA;IACI;;QAEI,oBAAoB;IACxB;AACJ;AACA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB;;8BAE0B;IAC1B,2CAA2C;IAC3C,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB;oDACgD;AACpD;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,mBAAmB;IACnB;;;;;;KAMC;IACD,8EAA8E;IAE9E,uBAAuB;IACvB,oBAAoB;AACxB;AACA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,sDAAsD;AAC1D;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,WAAW;IACX;;;;;KAKC;AACL;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,wDAAwD;IACxD,0DAA0D;AAC9D;AACA;IACI;QACI,8DAA8D;QAC9D,gEAAgE;IACpE;AACJ;AACA;IACI;QACI,4DAA4D;QAC5D,8DAA8D;IAClE;AACJ;;AAEA,gCAAgC;AAChC;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,sCAAsC;IACtC,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,yDAAqT;IACrT,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,0CAA0C;IAC1C,gCAAgC;IAChC,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI;QACI,mBAAmB;QACnB,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,wCAAwC;IACxC,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,gBAAgB;IAChB,0EAA0E;IAC1E,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,8CAA8C;IAC9C,iDAAiD;IACjD,sFAAsF;AAC1F;AACA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,YAAY;AAChB;AACA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,2CAA2C;IAC3C,+BAA+B;IAC/B,iEAAiE;AACrE;AACA;IACI,sCAAsC;IACtC,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,+BAA+B;IAC/B,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;;;;IAII,aAAa;AACjB;AACA;IACI;QACI,SAAS;QACT,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,2CAA2C;IAC3C,mBAAmB;AACvB;AACA;IACI;QACI,qBAAqB;IACzB;AACJ;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE,aAAa,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE,aAAa,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE;;AAE5C;IACI,uBAAuB,mBAAmB,EAAE;IAC5C,uBAAuB,mBAAmB,EAAE,kBAAkB,EAAE;IAChE,uBAAuB,mBAAmB,EAAE,iBAAiB,EAAE;IAC/D,uBAAuB,mBAAmB,EAAE;AAChD;;AAEA;IACI,uBAAuB,gBAAgB,EAAE;IACzC,uBAAuB,mBAAmB,EAAE;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yDAAyD;AAC7D;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;;;;KAKC;AACL;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,UAAU;AACd;AACA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,0CAA0C;IAC1C,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,qBAAqB,cAAc,EAAE;AACzC;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2CAA2C;IAC3C,gCAAgC;IAChC,2BAA2B;AAC/B;AACA;IACI;QACI,qCAAqC;QACrC,SAAS;QACT,uBAAuB;QACvB,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI;QACI,kBAAkB;QAClB,gDAAgD;IACpD;IACA,wBAAwB,kBAAkB,EAAE;AAChD;;AAEA;IACI;QACI,8CAA8C;QAC9C,oBAAoB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sFAAsF;IACtF,0CAA0C;IAC1C,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,0EAA0E;AAC9E;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb,kFAAkF;IAClF,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,qDAAqD;IACrD,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,gBAAgB;IAChB,qEAAqE;AACzE;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;AACA;IACI;QACI,qCAAqC;QACrC,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,sCAAsC;IACtC,sBAAsB;IACtB,2CAA2C;IAC3C;;;;KAIC;IACD,2BAA2B;IAC3B,gBAAgB;IAChB,6EAA6E;AACjF;AACA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;IACxB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,qDAAqD;IACrD,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI;QACI,WAAW;QACX,cAAc;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC,sDAAsD;IACtD,2BAA2B;AAC/B;AACA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,+BAA+B;IAC/B,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI;QACI,eAAe;QACf,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uFAAuF;IACvF,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,SAAO;IACP,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,mCAAmC;IACnC,0CAA0C;AAC9C;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA,0BAA0B;AAC1B;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,uCAAuC;IACvC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,gCAAgC;IAChC,0CAA0C;IAC1C,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,2CAA2C;IAC3C,gFAAgF;AACpF;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sFAAsF;IACtF,0CAA0C;IAC1C,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,0CAA0C;IAC1C,oCAAoC;AACxC;AACA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,iCAAiC;IACjC,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;IACrB,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,2CAA2C;IAC3C,iCAAiC;IACjC,gBAAgB;IAChB,8CAA8C;AAClD;AACA;IACI,sCAAsC;IACtC,qDAAqD;AACzD;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA,kBAAkB;;AA6BlB,2BAA2B;AAC3B;IACI;QACI,+CAA+C;QAC/C,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,yDAAyD;QACzD,UAAU;IACd;AACJ;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB;;;;;;KAMC;IACD,2CAA2C;IAC3C;yCACqC;IACrC,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;IACI;;;KAGC;IACD,0BAA0B;AAC9B;AA3rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,mBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA,QA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA,sBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,iDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,kDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,8BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,2GA4rCA;EA5rCA,yGA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,2GA4rCA;EA5rCA,yGA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,8BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,2GA4rCA;EA5rCA,yGA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,2GA4rCA;EA5rCA,yGA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,yBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,kBA4rCA;EA5rCA,kBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,+EA4rCA;EA5rCA,mGA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,yBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,yBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,sBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,qBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,qBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,gDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,iDA4rCA;EA5rCA;AA4rCA;AA5rCA;;EAAA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;AAAA;AA5rCA;EAAA;AA4rCA;AA5rCA;;EAAA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;AAAA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,0EA4rCA;EA5rCA,8FA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,qBA4rCA;EA5rCA,yBA4rCA;EA5rCA,2BA4rCA;EA5rCA,yBA4rCA;EA5rCA,0BA4rCA;EA5rCA,+BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,qBA4rCA;EA5rCA,yBA4rCA;EA5rCA,2BA4rCA;EA5rCA,yBA4rCA;EA5rCA,0BA4rCA;EA5rCA,+BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,qBA4rCA;EA5rCA,yBA4rCA;EA5rCA,2BA4rCA;EA5rCA,yBA4rCA;EA5rCA,0BA4rCA;EA5rCA,+BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA,yBA4rCA;EA5rCA,0BA4rCA;EA5rCA,wBA4rCA;EA5rCA,yBA4rCA;EA5rCA,8BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA,yBA4rCA;EA5rCA,0BA4rCA;EA5rCA,wBA4rCA;EA5rCA,yBA4rCA;EA5rCA,8BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA,yBA4rCA;EA5rCA,0BA4rCA;EA5rCA,wBA4rCA;EA5rCA,yBA4rCA;EA5rCA,8BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA,yBA4rCA;EA5rCA,0BA4rCA;EA5rCA,wBA4rCA;EA5rCA,yBA4rCA;EA5rCA,8BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA,sBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,0BA4rCA;EA5rCA,qBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,mBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;;EAAA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,oBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,uBA4rCA;IA5rCA,sDA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,uBA4rCA;IA5rCA,oDA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,uBA4rCA;IA5rCA,2DA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,iBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,iBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,iBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,iBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,mBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,eA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,eA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,mBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,kBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,kBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;AAAA;AA5rCA;;EAAA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,uBA4rCA;IA5rCA,8DA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,oBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,iBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,oBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,oBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,iBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,mBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,kBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,eA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,mBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,mBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,kBA4rCA;IA5rCA;EA4rCA;AAAA;AA5rCA;;EAAA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,gBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,iBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,mBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA,kBA4rCA;IA5rCA;EA4rCA;AAAA;AA5rCA;;EAAA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA;EA4rCA;;EA5rCA;IAAA,qBA4rCA;IA5rCA;EA4rCA;;EA5rCA;IAAA;EA4rCA;AAAA;AA5rCA;EAAA,kBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,kDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,iDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,iDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,kDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,kDA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,qBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,gBA4rCA;EA5rCA,oBA4rCA;EA5rCA,4BA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,sBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,WA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,kBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,mBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,qBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,kBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA,oBA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA,WA4rCA;EA5rCA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA;AA5rCA;EAAA;AA4rCA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* TOP WASH DOO — chrome + electric blue, dark stage */\n:root {\n    --tw-bg: #030812;\n    --tw-bg-2: #071223;\n    --tw-surface: #0c1a30;\n    --tw-fg: #eaf2ff;\n    --tw-muted: #8ea6c8;\n    --tw-blue: #1fa8ff;\n    --tw-blue-bright: #55d0ff;\n    --tw-blue-deep: #0b6cc9;\n    --tw-chrome-1: #f4f7fb;\n    --tw-chrome-2: #cfd8e6;\n    --tw-chrome-3: #8ea1b8;\n    --tw-border: rgba(139, 178, 226, 0.14);\n}\n\nhtml,\nbody {\n    background: var(--tw-bg);\n    color: var(--tw-fg);\n    overflow-x: hidden;\n    max-width: 100vw;\n}\n\nimg,\nvideo {\n    max-width: 100%;\n    height: auto;\n}\n\n/* Minimum touch target (44px) for mobile accessibility */\n.touch-target {\n    min-width: 44px;\n    min-height: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.safe-top {\n    padding-top: env(safe-area-inset-top, 0px);\n}\n\nbody {\n    margin: 0;\n    font-family:\n        \"Manrope\",\n        -apple-system,\n        BlinkMacSystemFont,\n        \"Segoe UI\",\n        Roboto,\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    overflow-x: hidden;\n}\n\n.font-display {\n    font-family: \"Archivo Black\", \"Manrope\", sans-serif;\n    letter-spacing: -0.02em;\n    font-style: italic;\n    text-transform: uppercase;\n}\n.font-display-str {\n    font-family: \"Archivo Black\", \"Manrope\", sans-serif;\n    letter-spacing: -0.02em;\n    text-transform: uppercase;\n}\n.font-heading {\n    font-family: \"Sora\", \"Manrope\", sans-serif;\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    line-height: 0.98;\n}\n.font-heading-md {\n    font-family: \"Sora\", \"Manrope\", sans-serif;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n}\n.font-sans-tw {\n    font-family: \"Manrope\", -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.overline {\n    font-family: \"Manrope\", sans-serif;\n    text-transform: uppercase;\n    letter-spacing: 0.18em;\n    font-size: 0.65rem;\n    font-weight: 700;\n    color: var(--tw-blue-bright);\n    line-height: 1.4;\n}\n@media (min-width: 640px) {\n    .overline {\n        letter-spacing: 0.28em;\n        font-size: 0.72rem;\n    }\n}\n\n/* Chrome/silver metallic text */\n.chrome-text {\n    background: linear-gradient(\n        180deg,\n        #ffffff 0%,\n        #dfe7f1 30%,\n        #8ea1b8 55%,\n        #ffffff 60%,\n        #cfd8e6 80%,\n        #6e7f96 100%\n    );\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    -webkit-text-stroke: 1px rgba(255, 255, 255, 0.14);\n    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.08);\n    filter: drop-shadow(0 6px 24px rgba(31, 168, 255, 0.35));\n}\n\n/* Electric blue heading */\n.blue-text {\n    background: linear-gradient(\n        180deg,\n        #a7e2ff 0%,\n        #55d0ff 35%,\n        #1fa8ff 55%,\n        #0b6cc9 100%\n    );\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    filter: drop-shadow(0 6px 24px rgba(31, 168, 255, 0.55));\n}\n\n/* Ambient glow blob */\n.glow-blob {\n    position: absolute;\n    filter: blur(80px);\n    opacity: 0.55;\n    pointer-events: none;\n    z-index: 0;\n}\n\n/* Selection */\n::selection {\n    background: var(--tw-blue);\n    color: #030812;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n}\n::-webkit-scrollbar-track {\n    background: var(--tw-bg);\n}\n::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, #1fa8ff, #0b6cc9);\n    border-radius: 999px;\n}\n\n/* Marquee */\n@keyframes tw-marquee {\n    from {\n        transform: translateX(0);\n    }\n    to {\n        transform: translateX(-50%);\n    }\n}\n.tw-marquee-track {\n    animation: tw-marquee 32s linear infinite;\n}\n\n/* Nav link */\n.tw-link {\n    position: relative;\n    display: inline-block;\n    padding-bottom: 3px;\n    color: rgba(234, 242, 255, 0.75);\n    transition: color 0.3s ease;\n}\n.tw-link:hover {\n    color: #55d0ff;\n}\n.tw-link::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 2px;\n    background: linear-gradient(90deg, #1fa8ff, #55d0ff);\n    transform-origin: right;\n    transform: scaleX(0);\n    transition: transform 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.tw-link:hover::after {\n    transform-origin: left;\n    transform: scaleX(1);\n}\n\n/* Buttons */\n.tw-btn {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    padding: 0.9rem 1.5rem;\n    background: linear-gradient(180deg, #55d0ff 0%, #1fa8ff 50%, #0b6cc9 100%);\n    color: #041225;\n    font-family: \"Archivo Black\", sans-serif;\n    font-weight: 900;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    font-size: 0.78rem;\n    border-radius: 999px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    box-shadow:\n        0 0 0 1px rgba(11, 108, 201, 0.5),\n        0 12px 32px -8px rgba(31, 168, 255, 0.6),\n        inset 0 1px 0 rgba(255, 255, 255, 0.5);\n    transition: transform 0.35s ease, box-shadow 0.35s ease, filter 0.35s ease;\n}\n.tw-btn:hover {\n    transform: translateY(-2px) scale(1.02);\n    filter: brightness(1.08);\n    box-shadow:\n        0 0 0 1px rgba(85, 208, 255, 0.7),\n        0 18px 42px -6px rgba(31, 168, 255, 0.8),\n        inset 0 1px 0 rgba(255, 255, 255, 0.6);\n}\n\n.tw-btn-ghost {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    padding: 0.9rem 1.5rem;\n    background: rgba(255, 255, 255, 0.04);\n    color: #eaf2ff;\n    border: 1px solid rgba(139, 178, 226, 0.35);\n    backdrop-filter: blur(12px);\n    font-family: \"Archivo Black\", sans-serif;\n    font-weight: 900;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    font-size: 0.78rem;\n    border-radius: 999px;\n    transition: all 0.35s ease;\n}\n@media (min-width: 640px) {\n    .tw-btn,\n    .tw-btn-ghost {\n        padding: 1rem 1.8rem;\n    }\n}\n.tw-btn-ghost:hover {\n    background: rgba(31, 168, 255, 0.12);\n    border-color: rgba(85, 208, 255, 0.7);\n    color: #55d0ff;\n}\n\n/* Card with glass + chrome border */\n.tw-card {\n    position: relative;\n    background:\n        linear-gradient(180deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0) 100%),\n        rgba(12, 26, 48, 0.55);\n    border: 1px solid rgba(139, 178, 226, 0.14);\n    border-radius: 16px;\n    backdrop-filter: blur(14px);\n    overflow: hidden;\n    transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1),\n        border-color 0.4s ease, box-shadow 0.4s ease;\n}\n@media (min-width: 640px) {\n    .tw-card {\n        border-radius: 20px;\n    }\n}\n@media (min-width: 768px) {\n    .tw-card {\n        border-radius: 24px;\n    }\n}\n.tw-card::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    padding: 1px;\n    border-radius: 24px;\n    background: linear-gradient(\n        140deg,\n        rgba(85, 208, 255, 0.35),\n        rgba(139, 178, 226, 0.06) 40%,\n        rgba(85, 208, 255, 0) 65%,\n        rgba(85, 208, 255, 0.25) 100%\n    );\n    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    pointer-events: none;\n}\n.tw-card:hover {\n    transform: translateY(-6px);\n    border-color: rgba(85, 208, 255, 0.4);\n    box-shadow: 0 30px 60px -20px rgba(31, 168, 255, 0.28);\n}\n\n/* Grid divider lines */\n.tw-hr {\n    height: 1px;\n    width: 100%;\n    background: linear-gradient(\n        90deg,\n        transparent,\n        rgba(139, 178, 226, 0.28),\n        transparent\n    );\n}\n\n/* Section base */\n.tw-section {\n    position: relative;\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n}\n@media (min-width: 640px) {\n    .tw-section {\n        padding-top: 5rem;\n        padding-bottom: 5rem;\n    }\n}\n@media (min-width: 768px) {\n    .tw-section {\n        padding-top: 8rem;\n        padding-bottom: 8rem;\n    }\n}\n\n/* Layout container */\n.tw-container {\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: max(1rem, env(safe-area-inset-left, 1rem));\n    padding-right: max(1rem, env(safe-area-inset-right, 1rem));\n}\n@media (min-width: 640px) {\n    .tw-container {\n        padding-left: max(1.25rem, env(safe-area-inset-left, 1.25rem));\n        padding-right: max(1.25rem, env(safe-area-inset-right, 1.25rem));\n    }\n}\n@media (min-width: 768px) {\n    .tw-container {\n        padding-left: max(2.5rem, env(safe-area-inset-left, 2.5rem));\n        padding-right: max(2.5rem, env(safe-area-inset-right, 2.5rem));\n    }\n}\n\n/* Responsive section headings */\n.tw-heading-section {\n    font-family: \"Sora\", \"Manrope\", sans-serif;\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    line-height: 1.05;\n    font-size: clamp(2rem, 5.5vw, 3.75rem);\n    color: #ffffff;\n}\n\n/* ─── Luxury Hero ─── */\n.hero-luxury .hero-grain {\n    background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n    mix-blend-mode: overlay;\n    pointer-events: none;\n}\n\n.hero-badge {\n    display: inline-flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    max-width: 100%;\n    padding: 0.5rem 0.85rem;\n    border-radius: 999px;\n    border: 1px solid rgba(85, 208, 255, 0.28);\n    background: rgba(3, 8, 18, 0.55);\n    backdrop-filter: blur(14px);\n    font-size: 0.58rem;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: #a7e2ff;\n}\n@media (min-width: 640px) {\n    .hero-badge {\n        align-items: center;\n        font-size: 0.72rem;\n        letter-spacing: 0.22em;\n        padding: 0.6rem 1.15rem;\n        gap: 0.6rem;\n    }\n}\n\n.hero-title {\n    font-family: \"Sora\", \"Manrope\", sans-serif;\n    font-weight: 300;\n    font-size: clamp(1.65rem, 5.5vw, 4.5rem);\n    line-height: 1.12;\n    letter-spacing: -0.03em;\n    color: #ffffff;\n}\n@media (min-width: 640px) {\n    .hero-title {\n        line-height: 1.08;\n    }\n}\n.hero-title-accent {\n    font-weight: 700;\n    background: linear-gradient(135deg, #e8f4ff 0%, #55d0ff 45%, #1fa8ff 100%);\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n}\n\n.hero-usps {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.5rem 1rem;\n}\n@media (min-width: 480px) {\n    .hero-usps {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n.hero-usp {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: #c8d6ec;\n    line-height: 1.4;\n}\n@media (min-width: 640px) {\n    .hero-usp {\n        font-size: 0.82rem;\n    }\n}\n\n/* ─── Partner strip ─── */\n.partner-strip {\n    padding: 3rem 0;\n    border-top: 1px solid rgba(85, 208, 255, 0.08);\n    border-bottom: 1px solid rgba(85, 208, 255, 0.08);\n    background: linear-gradient(180deg, rgba(6, 16, 31, 0.6) 0%, rgba(3, 8, 18, 0.3) 100%);\n}\n@media (min-width: 640px) {\n    .partner-strip {\n        padding: 4rem 0;\n    }\n}\n\n.partner-logos {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n}\n@media (min-width: 640px) {\n    .partner-logos {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 1rem;\n    }\n}\n\n.partner-logo {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    padding: 0.85rem 1rem;\n    border-radius: 1rem;\n    border: 1px solid rgba(139, 178, 226, 0.12);\n    background: rgba(3, 8, 18, 0.5);\n    transition: border-color 0.35s, background 0.35s, transform 0.35s;\n}\n.partner-logo:hover {\n    border-color: rgba(85, 208, 255, 0.35);\n    background: rgba(85, 208, 255, 0.06);\n    transform: translateY(-2px);\n}\n\n.partner-logo__img {\n    height: 1.75rem;\n    width: auto;\n    max-width: 100%;\n    object-fit: contain;\n    color: #ffffff;\n    opacity: 0.85;\n    filter: brightness(0) invert(1);\n    transition: opacity 0.35s;\n}\n.partner-logo:hover .partner-logo__img {\n    opacity: 1;\n}\n@media (min-width: 640px) {\n    .partner-logo__img {\n        height: 2rem;\n    }\n}\n\n.partner-logo__role {\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: #8ea6c8;\n    line-height: 1.3;\n}\n\n.hero-mosaic {\n    position: relative;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    gap: 0.5rem;\n    max-width: 340px;\n    margin: 0 auto;\n}\n.hero-mosaic--compact .hero-mosaic-item {\n    aspect-ratio: 1 / 1;\n}\n.hero-mosaic--compact .hero-mosaic-item--1,\n.hero-mosaic--compact .hero-mosaic-item--2,\n.hero-mosaic--compact .hero-mosaic-item--3,\n.hero-mosaic--compact .hero-mosaic-item--4 {\n    margin-top: 0;\n}\n@media (min-width: 640px) {\n    .hero-mosaic {\n        gap: 1rem;\n        max-width: none;\n    }\n    .hero-mosaic--compact .hero-mosaic-item {\n        aspect-ratio: 3 / 4;\n    }\n    .hero-mosaic--compact .hero-mosaic-item--2 {\n        margin-top: 1.5rem;\n    }\n    .hero-mosaic--compact .hero-mosaic-item--3 {\n        margin-top: -1rem;\n    }\n}\n@media (min-width: 1024px) {\n    .hero-mosaic {\n        gap: 1.15rem;\n    }\n}\n\n.hero-mosaic-item {\n    position: relative;\n    overflow: hidden;\n    border-radius: 1.25rem;\n    border: 1px solid rgba(139, 178, 226, 0.18);\n    aspect-ratio: 4 / 5;\n}\n@media (min-width: 640px) {\n    .hero-mosaic-item {\n        border-radius: 1.5rem;\n    }\n}\n.hero-mosaic-item--1 { aspect-ratio: 1 / 1; }\n.hero-mosaic-item--2 { aspect-ratio: 1 / 1; margin-top: 0; }\n.hero-mosaic-item--3 { aspect-ratio: 1 / 1; margin-top: 0; }\n.hero-mosaic-item--4 { aspect-ratio: 1 / 1; }\n\n@media (min-width: 640px) {\n    .hero-mosaic-item--1 { aspect-ratio: 3 / 4; }\n    .hero-mosaic-item--2 { aspect-ratio: 3 / 4; margin-top: 1.5rem; }\n    .hero-mosaic-item--3 { aspect-ratio: 3 / 4; margin-top: -1rem; }\n    .hero-mosaic-item--4 { aspect-ratio: 3 / 4; }\n}\n\n@media (min-width: 1024px) {\n    .hero-mosaic-item--2 { margin-top: 3rem; }\n    .hero-mosaic-item--3 { margin-top: -2.5rem; }\n}\n\n.hero-mosaic-item img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);\n}\n.hero-mosaic-item:hover img {\n    transform: scale(1.06);\n}\n\n.hero-mosaic-overlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(\n        to top,\n        rgba(3, 8, 18, 0.85) 0%,\n        rgba(3, 8, 18, 0.1) 55%,\n        transparent 100%\n    );\n}\n\n.hero-mosaic-label {\n    position: absolute;\n    left: 1rem;\n    bottom: 1rem;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.2em;\n    text-transform: uppercase;\n    color: #ffffff;\n    z-index: 2;\n}\n@media (min-width: 640px) {\n    .hero-mosaic-label {\n        font-size: 0.72rem;\n        left: 1.25rem;\n        bottom: 1.25rem;\n    }\n}\n\n.hero-mosaic-frame {\n    position: absolute;\n    inset: -8px;\n    border-radius: 1.75rem;\n    border: 1px solid rgba(85, 208, 255, 0.12);\n    pointer-events: none;\n    display: none;\n}\n@media (min-width: 1024px) {\n    .hero-mosaic-frame { display: block; }\n}\n\n.hero-stats {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n    padding: 1rem;\n    border-radius: 1.25rem;\n    border: 1px solid rgba(139, 178, 226, 0.14);\n    background: rgba(3, 8, 18, 0.65);\n    backdrop-filter: blur(16px);\n}\n@media (min-width: 640px) {\n    .hero-stats {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 1rem;\n        padding: 1.25rem 1.5rem;\n        border-radius: 1.5rem;\n    }\n}\n\n.hero-stat {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n    padding: 0.5rem 0;\n}\n@media (min-width: 640px) {\n    .hero-stat {\n        padding: 0.25rem 0;\n        border-right: 1px solid rgba(139, 178, 226, 0.1);\n    }\n    .hero-stat:last-child { border-right: none; }\n}\n\n@media (max-width: 639px) {\n    .hero-stat + .hero-stat {\n        border-top: 1px solid rgba(139, 178, 226, 0.1);\n        padding-top: 0.75rem;\n    }\n}\n\n.hero-stat-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 0.85rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, rgba(85, 208, 255, 0.2), rgba(11, 108, 201, 0.15));\n    border: 1px solid rgba(85, 208, 255, 0.25);\n    flex-shrink: 0;\n}\n\n/* ─── Process / How it works ─── */\n.process-section {\n    background: linear-gradient(180deg, #030812 0%, #06101f 45%, #030812 100%);\n}\n\n.process-section__glow {\n    position: absolute;\n    top: 30%;\n    left: 50%;\n    transform: translateX(-50%);\n    width: min(900px, 90vw);\n    height: 400px;\n    background: radial-gradient(ellipse, rgba(31, 168, 255, 0.12) 0%, transparent 70%);\n    pointer-events: none;\n}\n\n.process-progress {\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 2rem;\n    max-width: 1100px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.process-progress__segment {\n    display: flex;\n    align-items: center;\n    flex: 1;\n}\n\n.process-progress__segment:last-child {\n    flex: 0;\n}\n\n.process-progress__dot {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 999px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: \"Sora\", sans-serif;\n    font-weight: 800;\n    font-size: 0.75rem;\n    color: #ffffff;\n    background: linear-gradient(135deg, #55d0ff, #0b6cc9);\n    box-shadow: 0 0 24px rgba(31, 168, 255, 0.45);\n    flex-shrink: 0;\n}\n\n.process-progress__line {\n    flex: 1;\n    height: 2px;\n    margin: 0 0.5rem;\n    background: linear-gradient(90deg, #55d0ff, rgba(85, 208, 255, 0.15));\n}\n\n.process-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n@media (min-width: 640px) {\n    .process-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 1rem;\n    }\n}\n@media (min-width: 1024px) {\n    .process-grid {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 1.25rem;\n    }\n}\n\n.process-card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding: 1.5rem 1.25rem 1.5rem 1.75rem;\n    border-radius: 1.25rem;\n    border: 1px solid rgba(139, 178, 226, 0.12);\n    background: linear-gradient(\n        145deg,\n        rgba(12, 26, 48, 0.7) 0%,\n        rgba(3, 8, 18, 0.85) 100%\n    );\n    backdrop-filter: blur(12px);\n    overflow: hidden;\n    transition: border-color 0.4s ease, box-shadow 0.4s ease, transform 0.4s ease;\n}\n@media (min-width: 640px) {\n    .process-card {\n        padding: 1.75rem;\n        min-height: 320px;\n    }\n}\n@media (min-width: 1024px) {\n    .process-card {\n        min-height: 340px;\n        padding: 2rem 1.5rem;\n    }\n}\n\n.process-card::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 1.25rem;\n    bottom: 1.25rem;\n    width: 3px;\n    border-radius: 999px;\n    background: linear-gradient(180deg, #55d0ff, #0b6cc9);\n    opacity: 0.7;\n    transition: opacity 0.4s ease;\n}\n@media (min-width: 640px) {\n    .process-card::before {\n        top: 1.5rem;\n        bottom: 1.5rem;\n    }\n}\n\n.process-card:hover {\n    border-color: rgba(85, 208, 255, 0.35);\n    box-shadow: 0 20px 50px -20px rgba(31, 168, 255, 0.35);\n    transform: translateY(-4px);\n}\n.process-card:hover::before {\n    opacity: 1;\n}\n\n.process-card__watermark {\n    position: absolute;\n    top: -0.25rem;\n    right: 0.75rem;\n    font-family: \"Sora\", sans-serif;\n    font-weight: 800;\n    font-size: 4.5rem;\n    line-height: 1;\n    color: rgba(85, 208, 255, 0.06);\n    pointer-events: none;\n    user-select: none;\n}\n@media (min-width: 1024px) {\n    .process-card__watermark {\n        font-size: 5rem;\n        right: 0.5rem;\n    }\n}\n\n.process-card__vline {\n    display: none;\n}\n\n.process-card__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1.25rem;\n    position: relative;\n    z-index: 1;\n}\n\n.process-card__icon {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 0.9rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, rgba(85, 208, 255, 0.18), rgba(11, 108, 201, 0.12));\n    border: 1px solid rgba(85, 208, 255, 0.28);\n}\n\n.process-card__index {\n    font-family: \"Sora\", sans-serif;\n    font-weight: 800;\n    font-size: 0.8rem;\n    color: #55d0ff;\n    letter-spacing: 0.1em;\n}\n\n.process-card__title {\n    position: relative;\n    z-index: 1;\n    font-family: \"Sora\", sans-serif;\n    font-weight: 700;\n    font-size: 1.1rem;\n    line-height: 1.3;\n    color: #ffffff;\n    letter-spacing: -0.02em;\n}\n@media (min-width: 768px) {\n    .process-card__title {\n        font-size: 1.2rem;\n    }\n}\n\n.process-card__desc {\n    position: relative;\n    z-index: 1;\n    margin-top: 0.75rem;\n    flex: 1;\n    font-size: 0.875rem;\n    line-height: 1.65;\n    color: #a7bcd6;\n}\n@media (min-width: 768px) {\n    .process-card__desc {\n        font-size: 0.9rem;\n    }\n}\n\n.process-card__footer {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 1.25rem;\n    padding-top: 1.25rem;\n    border-top: 1px solid rgba(139, 178, 226, 0.1);\n}\n\n.process-card__tag {\n    display: inline-flex;\n    padding: 0.4rem 0.85rem;\n    border-radius: 999px;\n    font-size: 0.62rem;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: #a7e2ff;\n    background: rgba(85, 208, 255, 0.1);\n    border: 1px solid rgba(85, 208, 255, 0.22);\n}\n@media (min-width: 640px) {\n    .process-card__tag {\n        font-size: 0.65rem;\n    }\n}\n\n/* ─── Service pages ─── */\n.service-hero__title {\n    font-family: \"Sora\", \"Manrope\", sans-serif;\n    font-weight: 700;\n    font-size: clamp(1.75rem, 5vw, 3.25rem);\n    line-height: 1.1;\n    letter-spacing: -0.03em;\n    color: #ffffff;\n}\n\n.service-breadcrumb {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0.35rem 0.5rem;\n    font-size: 0.72rem;\n    color: #8ea6c8;\n}\n.service-breadcrumb a {\n    color: #a7e2ff;\n    transition: color 0.3s;\n}\n.service-breadcrumb a:hover {\n    color: #55d0ff;\n}\n.service-breadcrumb span[aria-current] {\n    color: #ffffff;\n}\n\n.service-highlights {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n}\n.service-highlight {\n    display: flex;\n    flex-direction: column;\n    padding: 0.65rem 1rem;\n    border-radius: 0.85rem;\n    background: rgba(3, 8, 18, 0.65);\n    border: 1px solid rgba(85, 208, 255, 0.18);\n    backdrop-filter: blur(10px);\n    min-width: 5.5rem;\n}\n.service-highlight__value {\n    font-family: \"Sora\", sans-serif;\n    font-weight: 800;\n    font-size: 0.95rem;\n    color: #ffffff;\n}\n.service-highlight__label {\n    font-size: 0.6rem;\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    color: #8ea6c8;\n    margin-top: 0.15rem;\n}\n\n.service-panel {\n    padding: 1.5rem;\n    border-radius: 1.25rem;\n    border: 1px solid rgba(139, 178, 226, 0.12);\n    background: linear-gradient(145deg, rgba(12, 26, 48, 0.55), rgba(3, 8, 18, 0.8));\n}\n@media (min-width: 640px) {\n    .service-panel {\n        padding: 2rem;\n    }\n}\n.service-panel__icon {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 0.85rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, rgba(85, 208, 255, 0.15), rgba(11, 108, 201, 0.1));\n    border: 1px solid rgba(85, 208, 255, 0.25);\n    margin-bottom: 1rem;\n}\n.service-panel__title {\n    font-family: \"Sora\", sans-serif;\n    font-weight: 700;\n    font-size: 1.15rem;\n    color: #ffffff;\n}\n\n.service-chip {\n    display: inline-flex;\n    padding: 0.4rem 0.9rem;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #c8d6ec;\n    background: rgba(85, 208, 255, 0.08);\n    border: 1px solid rgba(85, 208, 255, 0.15);\n}\n\n.service-content-block {\n    padding-bottom: 1.5rem;\n    border-bottom: 1px solid rgba(139, 178, 226, 0.08);\n}\n\n.service-local {\n    padding: 1.5rem;\n    border-radius: 1.25rem;\n    border: 1px solid rgba(85, 208, 255, 0.15);\n    background: rgba(85, 208, 255, 0.04);\n}\n@media (min-width: 640px) {\n    .service-local {\n        padding: 2rem;\n    }\n}\n\n.service-faq {\n    border-radius: 1rem;\n    border: 1px solid rgba(139, 178, 226, 0.12);\n    background: rgba(12, 26, 48, 0.4);\n    overflow: hidden;\n    transition: border-color 0.3s;\n}\n.service-faq[open] {\n    border-color: rgba(85, 208, 255, 0.3);\n}\n.service-faq__q {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 1rem 1.25rem;\n    font-family: \"Sora\", sans-serif;\n    font-weight: 600;\n    font-size: 0.9rem;\n    color: #ffffff;\n    cursor: pointer;\n    list-style: none;\n}\n.service-faq__q::-webkit-details-marker {\n    display: none;\n}\n.service-faq__chevron {\n    color: #55d0ff;\n    transition: transform 0.3s;\n}\n.service-faq[open] .service-faq__chevron {\n    transform: rotate(90deg);\n}\n.service-faq__a {\n    padding: 0 1.25rem 1.25rem;\n    font-size: 0.875rem;\n    line-height: 1.65;\n    color: #a7bcd6;\n}\n\n.service-related {\n    display: block;\n    border-radius: 1.25rem;\n    border: 1px solid rgba(139, 178, 226, 0.12);\n    background: rgba(12, 26, 48, 0.4);\n    overflow: hidden;\n    transition: border-color 0.4s, box-shadow 0.4s;\n}\n.service-related:hover {\n    border-color: rgba(85, 208, 255, 0.35);\n    box-shadow: 0 16px 40px -16px rgba(31, 168, 255, 0.3);\n}\n.service-related__img {\n    position: relative;\n    height: 10rem;\n    overflow: hidden;\n}\n@media (min-width: 640px) {\n    .service-related__img {\n        height: 11rem;\n    }\n}\n\n.service-cta-band {\n    background: linear-gradient(180deg, #06101f 0%, #030812 100%);\n    border-top: 1px solid rgba(85, 208, 255, 0.12);\n}\n\n.line-clamp-2 {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n\nhtml {\n    scroll-behavior: smooth;\n}\n\n/* Shadcn compat */\n@layer base {\n    :root {\n        --background: 220 60% 5%;\n        --foreground: 210 40% 96%;\n        --card: 220 55% 8%;\n        --card-foreground: 210 40% 96%;\n        --popover: 220 55% 8%;\n        --popover-foreground: 210 40% 96%;\n        --primary: 202 100% 56%;\n        --primary-foreground: 220 60% 5%;\n        --secondary: 220 40% 14%;\n        --secondary-foreground: 210 40% 96%;\n        --muted: 220 40% 14%;\n        --muted-foreground: 214 30% 68%;\n        --accent: 202 100% 56%;\n        --accent-foreground: 220 60% 5%;\n        --destructive: 0 62% 45%;\n        --destructive-foreground: 210 40% 96%;\n        --border: 220 30% 20%;\n        --input: 220 30% 20%;\n        --ring: 202 100% 56%;\n        --radius: 0.75rem;\n    }\n    * {\n        @apply border-border;\n    }\n}\n\n/* Bubble float animation */\n@keyframes bubble-float {\n    0% {\n        transform: translateY(0) translateX(0) scale(1);\n        opacity: 0;\n    }\n    10% {\n        opacity: 0.8;\n    }\n    90% {\n        opacity: 0.6;\n    }\n    100% {\n        transform: translateY(-120vh) translateX(20px) scale(0.6);\n        opacity: 0;\n    }\n}\n.bubble {\n    position: absolute;\n    border-radius: 999px;\n    background: radial-gradient(\n        circle at 30% 30%,\n        rgba(255, 255, 255, 0.6),\n        rgba(85, 208, 255, 0.3) 40%,\n        rgba(11, 108, 201, 0.05) 70%,\n        transparent 80%\n    );\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    box-shadow: inset 0 0 12px rgba(85, 208, 255, 0.35),\n        0 0 20px rgba(31, 168, 255, 0.25);\n    pointer-events: none;\n}\n\n/* Grid noise/dots background */\n.dots-bg {\n    background-image: radial-gradient(\n        rgba(85, 208, 255, 0.13) 1px,\n        transparent 1px\n    );\n    background-size: 26px 26px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
